export interface RoleMenuType {
  name: string
  path: string
  icon?: string
  code?: string
  id: string
  systemCode?: string
  selectIcon?: string
  appCode: string
  noTable?: boolean
  menuList?: RoleMenuType[]
  children?: RoleMenuType[]
}

export const virtualAppCodes = {
  FollowRecord: 'virtual0000000000000000000000001', //跟进记录
  FollowStatistics: 'virtual0000000000000000000000002', //跟进统计
  CustomSource: 'virtual0000000000000000000000003', //自定义来源
  ApiChannelTraffic: 'virtual0000000000000000000000004', //API渠道流量
  TransactionRecord: 'virtual0000000000000000000000005', //交易记录
  BalanceMarginManagement: 'virtual0000000000000000000000006', //保证金余额管理
  StoreItem: 'virtual0000000000000000000000007', //应用商城
  OrderMange: 'virtual0000000000000000000000008', //订单管理
  Purchase: 'virtual0000000000000000000000009', //已购商品
  MyCreatedContract: 'virtual0000000000000000000000010', //我发起的合同
  MyPartakeContract: 'virtual0000000000000000000000011', //我签署的合同
  FaceSignRecords: 'virtual0000000000000000000000012', //AI智能视频面签记录
  FaceSignWords: 'virtual0000000000000000000000013', //AI智能视频面签话术
  SeatList: 'virtual0000000000000000000000014', //坐席绑员工
  SeatLineList: 'virtual0000000000000000000000015', //坐席绑线路
  SeatGroup: 'virtual0000000000000000000000016', //坐席分组
  PhoneList: 'virtual0000000000000000000000017', //话机管理
  WorkerList: 'virtual0000000000000000000000018', //工作机管理
  CustomerDetail: 'virtual0000000000000000000000019', //客户详情
  HighSeaDetail: 'virtual0000000000000000000000020', //公海详情
  RecycleBinDetail: 'virtual0000000000000000000000021', //回收站详情
  ClueDetail: 'virtual0000000000000000000000022', //线索详情
  ClueHighSeasDetail: 'virtual0000000000000000000000023', //线索公海详情
  ClueRecycleDetail: 'virtual0000000000000000000000024' //线索回收站详情
}
